export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  status: string;
  rating: number;
  description: string;
  latestChapter: string;
  updateDate: string;
  views: number;
  favorites: number;
  chapters: { number: number; title: string; date: string }[];
  comments: { id: string; user: string; avatar: string; rating: number; content: string; date: string }[];
}

export const allComics: Comic[] = [
  {
    id: '1',
    title: '我的野蛮王妃',
    author: '朴素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20illustration%2C%20elegant%20female%20character%20in%20traditional%20hanbok%20posing%20gracefully%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%20with%20cherry%20blossom%20petals%2C%20manga%20art%20style%20with%20delicate%20linework%2C%20clean%20simple%20background%20with%20warm%20cream%20tones&width=600&height=800&seq=comic-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    status: '连载中',
    rating: 4.8,
    description: '现代女孩穿越到古代宫廷，与冷傲王子的命运交织。一段跨越时空的甜蜜爱恋，在宫廷阴谋与权力斗争中悄然绽放。她凭借现代智慧和率真性格，一步步赢得了王子的心，也改变了自己的命运。',
    latestChapter: '第128话',
    updateDate: '2026-07-03',
    views: 1280000,
    favorites: 35600,
    chapters: [
      { number: 128, title: '最后的抉择', date: '2026-07-03' },
      { number: 127, title: '意外重逢', date: '2026-07-02' },
      { number: 126, title: '王宫的阴谋', date: '2026-07-01' },
      { number: 125, title: '命运的转折', date: '2026-06-30' },
      { number: 124, title: '暗流涌动', date: '2026-06-29' },
      { number: 123, title: '新的开始', date: '2026-06-28' },
      { number: 122, title: '真相浮现', date: '2026-06-27' },
      { number: 121, title: '危机降临', date: '2026-06-26' },
      { number: 120, title: '守护之心', date: '2026-06-25' },
      { number: 119, title: '误会重重', date: '2026-06-24' },
    ],
    comments: [
      { id: 'c1', user: '漫迷小丽', avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20profile%20avatar%2C%20simple%20clean%20background%2C%20warm%20pink%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish', rating: 5, content: '这部漫画追了三年了，画风越来越精致，剧情也越来越精彩！每周都在等更新。', date: '2026-07-03' },
      { id: 'c2', user: '韩剧达人', avatar: 'https://readdy.ai/api/search-image?query=handsome%20anime%20style%20male%20profile%20avatar%2C%20simple%20clean%20background%2C%20cool%20blue%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish', rating: 4, content: '画师功力太强了，每个人物都很有特色，配角的塑造也很用心。', date: '2026-07-02' },
      { id: 'c3', user: '漫画控', avatar: 'https://readdy.ai/api/search-image?query=chibi%20anime%20style%20cat%20girl%20profile%20avatar%2C%20simple%20clean%20background%2C%20pastel%20yellow%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish', rating: 5, content: '太好看了！每一话都让人期待下一话，剧情节奏把握得太好了。', date: '2026-07-01' },
      { id: 'c4', user: '追漫少女', avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20with%20glasses%20profile%20avatar%2C%20simple%20clean%20background%2C%20soft%20lavender%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish', rating: 5, content: '男主太帅了！这种冷酷外表温柔内心的设定永远吃不腻！', date: '2026-06-30' },
    ],
  },
  {
    id: '2',
    title: '剑与魔法',
    author: '金镇宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20illustration%2C%20powerful%20warrior%20holding%20a%20glowing%20sword%2C%20epic%20battle%20scene%20with%20magical%20effects%2C%20dark%20dramatic%20lighting%2C%20manga%20art%20style%20with%20bold%20linework%2C%20simple%20clean%20background%20with%20dark%20gradient&width=600&height=800&seq=comic-02&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.9,
    description: '在剑与魔法的异世界里，少年剑士踏上了复仇与成长的史诗征程。他从一名卑微的侍从，通过不懈努力与生死历练，最终成长为拯救世界的传奇英雄。',
    latestChapter: '第215话',
    updateDate: '2026-07-03',
    views: 2350000,
    favorites: 89200,
    chapters: [
      { number: 215, title: '最终的决战', date: '2026-07-03' },
      { number: 214, title: '觉醒的力量', date: '2026-07-01' },
      { number: 213, title: '传承的意志', date: '2026-06-29' },
      { number: 212, title: '黑暗降临', date: '2026-06-27' },
      { number: 211, title: '勇者集结', date: '2026-06-25' },
      { number: 210, title: '封印解除', date: '2026-06-23' },
      { number: 209, title: '深渊之战', date: '2026-06-21' },
      { number: 208, title: '力量觉醒', date: '2026-06-19' },
      { number: 207, title: '命运之轮', date: '2026-06-17' },
      { number: 206, title: '古遗迹的秘密', date: '2026-06-15' },
    ],
    comments: [
      { id: 'c5', user: '热血少年', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20cool%20boy%20profile%20avatar%2C%20spiky%20hair%2C%20simple%20clean%20background%2C%20fiery%20red%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-05&orientation=squarish', rating: 5, content: '战斗场面画得太燃了！每次看都热血沸腾！', date: '2026-07-03' },
      { id: 'c6', user: '异世界迷', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20mysterious%20boy%20profile%20avatar%2C%20long%20silver%20hair%2C%20simple%20clean%20background%2C%20cool%20blue%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-06&orientation=squarish', rating: 5, content: '世界观设定非常完整，魔法体系也很合理，看得出来作者花了大量心思。', date: '2026-07-02' },
    ],
  },
  {
    id: '3',
    title: '都市夜行',
    author: '郑允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20modern%20urban%20noir%20illustration%2C%20stylish%20detective%20character%20in%20trench%20coat%20standing%20in%20rainy%20city%20street%20at%20night%2C%20neon%20light%20reflections%2C%20moody%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20dark%20blue%20tones&width=600&height=800&seq=comic-03&orientation=portrait',
    category: '悬疑',
    categorySlug: 'suspense',
    status: '已完结',
    rating: 4.7,
    description: '夜幕下的都市暗藏秘密，一位私家侦探揭开了惊人真相。在霓虹灯闪烁的都市阴影中，连环案件接连发生，每个线索都指向一个更加黑暗的阴谋。',
    latestChapter: '第89话（终）',
    updateDate: '2026-06-15',
    views: 890000,
    favorites: 28500,
    chapters: [
      { number: 89, title: '真相大白', date: '2026-06-15' },
      { number: 88, title: '最后的嫌疑人', date: '2026-06-14' },
      { number: 87, title: '暗房中的秘密', date: '2026-06-13' },
      { number: 86, title: '追踪', date: '2026-06-12' },
      { number: 85, title: '意外的证人', date: '2026-06-11' },
      { number: 84, title: '线索断裂', date: '2026-06-10' },
      { number: 83, title: '深夜的来电', date: '2026-06-09' },
      { number: 82, title: '旧案重提', date: '2026-06-08' },
      { number: 81, title: '迷雾重重', date: '2026-06-07' },
      { number: 80, title: '第一个线索', date: '2026-06-06' },
    ],
    comments: [
      { id: 'c7', user: '推理迷', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20intelligent%20boy%20profile%20avatar%2C%20wearing%20glasses%2C%20simple%20clean%20background%2C%20warm%20brown%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-07&orientation=squarish', rating: 5, content: '结局反转太精彩了！完全没想到凶手是谁，作者伏笔埋得太深了。', date: '2026-06-16' },
      { id: 'c8', user: '夜猫子', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20cool%20girl%20profile%20avatar%2C%20dark%20hair%2C%20simple%20clean%20background%2C%20deep%20purple%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-08&orientation=squarish', rating: 4, content: '画风特别有氛围感，夜晚都市的描绘让人身临其境。', date: '2026-06-15' },
    ],
  },
  {
    id: '4',
    title: '甜蜜契约',
    author: '李美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20illustration%2C%20cute%20couple%20characters%20holding%20hands%20in%20spring%20park%2C%20soft%20sunlight%20filtering%20through%20trees%2C%20gentle%20warm%20color%20palette%2C%20manga%20art%20style%20with%20soft%20linework%2C%20clean%20simple%20background%20with%20pastel%20green%20tones&width=600&height=800&seq=comic-04&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    status: '连载中',
    rating: 4.6,
    description: '一份意外的契约，让两个性格迥异的人走到了一起。冰山总裁与元气少女的同居生活，从互相看不顺眼到日久生情，甜蜜又爆笑。',
    latestChapter: '第56话',
    updateDate: '2026-07-02',
    views: 650000,
    favorites: 18500,
    chapters: [
      { number: 56, title: '心动的瞬间', date: '2026-07-02' },
      { number: 55, title: '意外告白', date: '2026-06-30' },
      { number: 54, title: '约会风波', date: '2026-06-28' },
      { number: 53, title: '契约到期', date: '2026-06-26' },
      { number: 52, title: '误会解除', date: '2026-06-24' },
      { number: 51, title: '前女友归来', date: '2026-06-22' },
      { number: 50, title: '心动加速', date: '2026-06-20' },
      { number: 49, title: '烛光晚餐', date: '2026-06-18' },
      { number: 48, title: '吃醋了', date: '2026-06-16' },
      { number: 47, title: '同事聚餐', date: '2026-06-14' },
    ],
    comments: [
      { id: 'c9', user: '甜饼女孩', avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20profile%20avatar%2C%20smiling%20brightly%2C%20simple%20clean%20background%2C%20soft%20peach%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-09&orientation=squarish', rating: 5, content: '太甜了太甜了！每次看完都要在被窝里打滚，少女心爆棚！', date: '2026-07-02' },
    ],
  },
  {
    id: '5',
    title: '武道至尊',
    author: '姜泰元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20illustration%2C%20fierce%20fighter%20in%20dynamic%20combat%20pose%20with%20energy%20aura%2C%20intense%20expression%2C%20dramatic%20lighting%20with%20warm%20orange%20accents%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20warm%20beige%20tones&width=600&height=800&seq=comic-05&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.8,
    description: '少年在武道世界一路披荆斩棘，成为至尊的传奇故事。从被家族抛弃的废材，到觉醒远古血脉、踏碎苍穹，他用自己的双拳证明了一切。',
    latestChapter: '第312话',
    updateDate: '2026-07-03',
    views: 3100000,
    favorites: 105000,
    chapters: [
      { number: 312, title: '至尊之战', date: '2026-07-03' },
      { number: 311, title: '血脉觉醒', date: '2026-07-01' },
      { number: 310, title: '武道真意', date: '2026-06-29' },
      { number: 309, title: '决战前夕', date: '2026-06-27' },
      { number: 308, title: '强敌来袭', date: '2026-06-25' },
      { number: 307, title: '秘境探险', date: '2026-06-23' },
      { number: 306, title: '传承考验', date: '2026-06-21' },
      { number: 305, title: '力战群雄', date: '2026-06-19' },
      { number: 304, title: '突破瓶颈', date: '2026-06-17' },
      { number: 303, title: '新的境界', date: '2026-06-15' },
    ],
    comments: [
      { id: 'c10', user: '武痴', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20muscular%20boy%20profile%20avatar%2C%20determined%20expression%2C%20simple%20clean%20background%2C%20warm%20bronze%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-10&orientation=squarish', rating: 5, content: '男主太霸气了！每次逆袭的场面都看得很爽，根本不按套路出牌。', date: '2026-07-03' },
      { id: 'c11', user: '修仙党', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20long%20haired%20boy%20profile%20avatar%2C%20calm%20expression%2C%20simple%20clean%20background%2C%20cool%20teal%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-11&orientation=squarish', rating: 4, content: '升级节奏很快，不拖泥带水，看得很爽。', date: '2026-07-01' },
    ],
  },
  {
    id: '6',
    title: '星之彼岸',
    author: '崔智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20fantasy%20illustration%2C%20beautiful%20female%20astronaut%20floating%20in%20starry%20space%2C%20galaxy%20nebula%20background%2C%20ethereal%20glowing%20effects%2C%20dreamy%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20deep%20space%20tones&width=600&height=800&seq=comic-06&orientation=portrait',
    category: '科幻',
    categorySlug: 'sf',
    status: '连载中',
    rating: 4.5,
    description: '地球毁灭后，人类在宇宙中寻找新的家园。少女宇航员在星际旅途中发现了关于人类起源的惊天秘密，以及隐藏在宇宙深处的古老文明。',
    latestChapter: '第78话',
    updateDate: '2026-07-01',
    views: 520000,
    favorites: 14200,
    chapters: [
      { number: 78, title: '星际之门', date: '2026-07-01' },
      { number: 77, title: '古老信号', date: '2026-06-29' },
      { number: 76, title: '虫洞穿越', date: '2026-06-27' },
      { number: 75, title: '新星球', date: '2026-06-25' },
      { number: 74, title: '外星遗迹', date: '2026-06-23' },
      { number: 73, title: '文明对话', date: '2026-06-21' },
    ],
    comments: [
      { id: 'c12', user: '太空迷', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20futuristic%20girl%20profile%20avatar%2C%20short%20silver%20hair%2C%20simple%20clean%20background%2C%20cool%20space%20blue%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-12&orientation=squarish', rating: 5, content: '科幻设定太有想象力了！星际旅行、外星文明、时间悖论，元素满满。', date: '2026-07-01' },
    ],
  },
  {
    id: '7',
    title: '搞笑日常',
    author: '朴正勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20illustration%2C%20group%20of%20funny%20cartoon%20characters%20doing%20hilarious%20activities%2C%20exaggerated%20expressions%2C%20bright%20cheerful%20color%20palette%2C%20manga%20art%20style%20with%20playful%20linework%2C%20clean%20simple%20background%20with%20warm%20sunny%20yellow%20tones&width=600&height=800&seq=comic-07&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.4,
    description: '三个大学室友的爆笑日常，从考试周的地狱到假期旅行的灾难，每一话都让你笑到肚子疼。贴近生活的搞笑桥段，看完仿佛看到了自己的影子。',
    latestChapter: '第102话',
    updateDate: '2026-07-03',
    views: 780000,
    favorites: 22000,
    chapters: [
      { number: 102, title: '暑假计划', date: '2026-07-03' },
      { number: 101, title: '期末地狱', date: '2026-07-01' },
      { number: 100, title: '百话纪念', date: '2026-06-29' },
      { number: 99, title: '社团招新', date: '2026-06-27' },
      { number: 98, title: '减肥计划', date: '2026-06-25' },
      { number: 97, title: '宿舍料理', date: '2026-06-23' },
    ],
    comments: [
      { id: 'c13', user: '笑口常开', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20cheerful%20boy%20profile%20avatar%2C%20laughing%20expression%2C%20simple%20clean%20background%2C%20warm%20orange%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-13&orientation=squarish', rating: 5, content: '每次心情不好就来看这个，笑得停不下来！室友三人组太真实了。', date: '2026-07-03' },
    ],
  },
  {
    id: '8',
    title: '暗夜回响',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20illustration%2C%20eerie%20haunted%20mansion%20with%20ghostly%20figure%20in%20window%2C%20dark%20gothic%20atmosphere%2C%20moonlit%20shadows%2C%20foggy%20surroundings%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20deep%20black%20and%20crimson%20tones&width=600&height=800&seq=comic-08&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    status: '连载中',
    rating: 4.3,
    description: '搬进老宅的女孩每晚都能听到墙壁里的低语声，随着调查深入，她发现这栋房子隐藏着一个跨越百年的诅咒。恐怖氛围拉满，胆小慎入。',
    latestChapter: '第45话',
    updateDate: '2026-07-02',
    views: 430000,
    favorites: 12800,
    chapters: [
      { number: 45, title: '诅咒源头', date: '2026-07-02' },
      { number: 44, title: '百年往事', date: '2026-06-30' },
      { number: 43, title: '镜中人', date: '2026-06-28' },
      { number: 42, title: '地下密室', date: '2026-06-26' },
      { number: 41, title: '夜半歌声', date: '2026-06-24' },
      { number: 40, title: '第一滴血', date: '2026-06-22' },
    ],
    comments: [
      { id: 'c14', user: '恐怖爱好者', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20mysterious%20girl%20profile%20avatar%2C%20dark%20hair%20covering%20one%20eye%2C%20simple%20clean%20background%2C%20dark%20purple%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-14&orientation=squarish', rating: 5, content: '氛围营造得太好了！半夜看真的有点吓人，但就是停不下来。', date: '2026-07-02' },
    ],
  },
  {
    id: '9',
    title: '校园时光',
    author: '郑秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20slice%20of%20life%20illustration%2C%20cheerful%20students%20in%20school%20uniforms%20walking%20in%20cherry%20blossom%20lined%20campus%2C%20warm%20afternoon%20sunlight%2C%20nostalgic%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20soft%20pink%20and%20cream%20tones&width=600&height=800&seq=comic-09&orientation=portrait',
    category: '日常',
    categorySlug: 'daily',
    status: '连载中',
    rating: 4.5,
    description: '普通高中生们的温馨校园日常，友情、暗恋、考试、社团活动，平凡的每一天都闪闪发光。没有大起大落，只有细水长流的温暖。',
    latestChapter: '第67话',
    updateDate: '2026-07-03',
    views: 560000,
    favorites: 16500,
    chapters: [
      { number: 67, title: '毕业典礼', date: '2026-07-03' },
      { number: 66, title: '最后告白', date: '2026-07-01' },
      { number: 65, title: '文化祭', date: '2026-06-29' },
      { number: 64, title: '修学旅行', date: '2026-06-27' },
      { number: 63, title: '模拟考', date: '2026-06-25' },
      { number: 62, title: '运动会', date: '2026-06-23' },
    ],
    comments: [
      { id: 'c15', user: '怀旧派', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20gentle%20girl%20profile%20avatar%2C%20long%20straight%20hair%2C%20simple%20clean%20background%2C%20soft%20cream%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-15&orientation=squarish', rating: 5, content: '看哭了，好像回到了自己的高中时代，那些人和那些事。', date: '2026-07-03' },
    ],
  },
  {
    id: '10',
    title: '异能觉醒',
    author: '李明浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20superpower%20action%20illustration%2C%20young%20man%20with%20glowing%20electric%20powers%20emanating%20from%20hands%2C%20dynamic%20action%20pose%2C%20dramatic%20lightning%20effects%2C%20intense%20expression%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20dark%20electric%20blue%20tones&width=600&height=800&seq=comic-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 4.6,
    description: '普通高中生意外觉醒了超能力，却因此被卷入超能力者之间的暗战。在善与恶的边界徘徊，他必须在力量与良知之间做出选择。',
    latestChapter: '第134话',
    updateDate: '2026-07-03',
    views: 980000,
    favorites: 31000,
    chapters: [
      { number: 134, title: '能力暴走', date: '2026-07-03' },
      { number: 133, title: '暗流涌动', date: '2026-07-01' },
      { number: 132, title: '秘密基地', date: '2026-06-29' },
      { number: 131, title: '异能对决', date: '2026-06-27' },
      { number: 130, title: '觉醒之日', date: '2026-06-25' },
    ],
    comments: [
      { id: 'c16', user: '超能力粉', avatar: 'https://readdy.ai/api/search-image?query=anime%20style%20energetic%20boy%20profile%20avatar%2C%20lightning%20motif%2C%20simple%20clean%20background%2C%20electric%20blue%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-16&orientation=squarish', rating: 5, content: '超能力战斗画得太帅了！每次能力爆发都看得肾上腺素飙升。', date: '2026-07-03' },
    ],
  },
  {
    id: '11',
    title: '魔法学院',
    author: '韩智雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magical%20school%20illustration%2C%20beautiful%20female%20student%20in%20elegant%20magic%20academy%20uniform%20holding%20glowing%20spell%20book%2C%20enchanted%20library%20background%20with%20floating%20books%2C%20warm%20magical%20light%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20warm%20golden%20amber%20tones&width=600&height=800&seq=comic-11&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 4.7,
    description: '平凡少女进入魔法学院，从吊车尾到天才魔法师的逆袭之路。友情、竞争、初恋，魔法世界的冒险才刚刚开始。',
    latestChapter: '第89话',
    updateDate: '2026-07-02',
    views: 720000,
    favorites: 21000,
    chapters: [
      { number: 89, title: '魔法竞赛', date: '2026-07-02' },
      { number: 88, title: '秘密教室', date: '2026-06-30' },
      { number: 87, title: '禁书之谜', date: '2026-06-28' },
      { number: 86, title: '魔法对决', date: '2026-06-26' },
      { number: 85, title: '入学考试', date: '2026-06-24' },
    ],
    comments: [],
  },
  {
    id: '12',
    title: '心跳信号',
    author: '金恩熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20shy%20girl%20and%20cool%20guy%20sitting%20close%20together%20on%20school%20rooftop%20at%20sunset%2C%20romantic%20warm%20lighting%2C%20gentle%20breeze%20moving%20hair%2C%20manga%20art%20style%20with%20delicate%20soft%20linework%2C%20clean%20simple%20background%20with%20warm%20sunset%20orange%20and%20pink%20tones&width=600&height=800&seq=comic-12&orientation=portrait',
    category: '恋爱',
    categorySlug: 'love',
    status: '连载中',
    rating: 4.5,
    description: '性格内向的女孩暗恋学校最受欢迎的男生，一场意外让两人产生了交集。青涩的校园恋爱，每一个心跳的瞬间都珍贵无比。',
    latestChapter: '第43话',
    updateDate: '2026-07-03',
    views: 480000,
    favorites: 13500,
    chapters: [
      { number: 43, title: '初恋确认', date: '2026-07-03' },
      { number: 42, title: '误会解除', date: '2026-07-01' },
      { number: 41, title: '天台告白', date: '2026-06-29' },
      { number: 40, title: '运动会', date: '2026-06-27' },
      { number: 39, title: '情人节', date: '2026-06-25' },
    ],
    comments: [],
  },
  {
    id: '13',
    title: '深渊追踪',
    author: '郑泰焕',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20thriller%20illustration%2C%20lone%20detective%20with%20flashlight%20investigating%20dark%20underground%20tunnel%2C%20ominous%20shadows%2C%20mysterious%20glowing%20symbols%20on%20walls%2C%20tense%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20dark%20teal%20and%20black%20tones&width=600&height=800&seq=comic-13&orientation=portrait',
    category: '悬疑',
    categorySlug: 'suspense',
    status: '连载中',
    rating: 4.6,
    description: '城市中接连出现离奇失踪案件，刑警深入调查后发现所有线索都指向城市地下的废弃隧道系统。而隧道深处，似乎有什么东西在等待着他们。',
    latestChapter: '第57话',
    updateDate: '2026-07-01',
    views: 610000,
    favorites: 17800,
    chapters: [
      { number: 57, title: '地下迷宫', date: '2026-07-01' },
      { number: 56, title: '新受害者', date: '2026-06-29' },
      { number: 55, title: '监控录像', date: '2026-06-27' },
      { number: 54, title: '目击者', date: '2026-06-25' },
      { number: 53, title: '第一个案件', date: '2026-06-23' },
    ],
    comments: [],
  },
  {
    id: '14',
    title: '未来纪元',
    author: '姜艺珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cyberpunk%20sci-fi%20illustration%2C%20futuristic%20cityscape%20with%20flying%20vehicles%20and%20holographic%20billboards%2C%20android%20girl%20with%20glowing%20eyes%20standing%20on%20rooftop%2C%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20cyberpunk%20teal%20and%20magenta%20tones&width=600&height=800&seq=comic-14&orientation=portrait',
    category: '科幻',
    categorySlug: 'sf',
    status: '连载中',
    rating: 4.4,
    description: '2077年的新首尔，人类与AI共存的赛博朋克世界。一名记忆猎人偶然发现了一个足以颠覆整个社会秩序的惊天秘密。',
    latestChapter: '第36话',
    updateDate: '2026-07-02',
    views: 380000,
    favorites: 9800,
    chapters: [
      { number: 36, title: '记忆提取', date: '2026-07-02' },
      { number: 35, title: '虚拟监狱', date: '2026-06-30' },
      { number: 34, title: '黑客联盟', date: '2026-06-28' },
      { number: 33, title: '数据风暴', date: '2026-06-26' },
      { number: 32, title: '觉醒程序', date: '2026-06-24' },
    ],
    comments: [],
  },
  {
    id: '15',
    title: '勇者食堂',
    author: '朴恩英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20fantasy%20illustration%2C%20cute%20chef%20character%20in%20medieval%20apron%20preparing%20magical%20glowing%20dishes%2C%20fantasy%20kitchen%20with%20potions%20and%20enchanted%20ingredients%2C%20warm%20cozy%20lighting%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20warm%20golden%20and%20sage%20green%20tones&width=600&height=800&seq=comic-15&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 4.3,
    description: '在异世界开餐厅的退休勇者，用美味料理征服各路冒险者。怪物肉料理、龙息烤肉、史莱姆甜点——勇者食堂，异世界最强美食传说。',
    latestChapter: '第71话',
    updateDate: '2026-07-03',
    views: 520000,
    favorites: 15200,
    chapters: [
      { number: 71, title: '龙肉烧烤', date: '2026-07-03' },
      { number: 70, title: '魔王点餐', date: '2026-07-01' },
      { number: 69, title: '新品上市', date: '2026-06-29' },
      { number: 68, title: '食评大战', date: '2026-06-27' },
      { number: 67, title: '秘方泄露', date: '2026-06-25' },
    ],
    comments: [],
  },
  {
    id: '16',
    title: '幽灵公寓',
    author: '崔敏秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20ghost%20comedy%20illustration%2C%20cute%20ghost%20characters%20living%20in%20old%20apartment%20building%2C%20playful%20mischievous%20spirits%20interacting%20with%20human%20tenant%2C%20humorous%20spooky%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20soft%20lavender%20and%20warm%20candlelight%20tones&width=600&height=800&seq=comic-16&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    status: '连载中',
    rating: 4.2,
    description: '搬进老旧公寓的女大学生发现这里住着一群可爱的幽灵室友。恐怖变搞笑，惊悚变温馨，人鬼同居的爆笑日常就此展开。',
    latestChapter: '第28话',
    updateDate: '2026-07-01',
    views: 290000,
    favorites: 7600,
    chapters: [
      { number: 28, title: '幽灵派对', date: '2026-07-01' },
      { number: 27, title: '驱魔师来访', date: '2026-06-29' },
      { number: 26, title: '鬼节庆典', date: '2026-06-27' },
      { number: 25, title: '午夜厨房', date: '2026-06-25' },
      { number: 24, title: '搬家风波', date: '2026-06-23' },
    ],
    comments: [],
  },
  {
    id: '17',
    title: '猫咖物语',
    author: '李秀妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20illustration%2C%20cozy%20cat%20cafe%20interior%20with%20cute%20cats%20sleeping%20on%20shelves%2C%20warm%20girl%20barista%20serving%20coffee%2C%20soft%20afternoon%20sunlight%20through%20windows%2C%20peaceful%20healing%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20warm%20cream%20and%20soft%20brown%20tones&width=600&height=800&seq=comic-17&orientation=portrait',
    category: '日常',
    categorySlug: 'daily',
    status: '连载中',
    rating: 4.6,
    description: '在街角的小小猫咪咖啡馆里，每天都上演着温暖治愈的故事。流浪猫、常客、新员工——在这个小小的空间里，每个人都在慢慢被治愈。',
    latestChapter: '第52话',
    updateDate: '2026-07-02',
    views: 420000,
    favorites: 11800,
    chapters: [
      { number: 52, title: '新猫咪', date: '2026-07-02' },
      { number: 51, title: '雨天客人', date: '2026-06-30' },
      { number: 50, title: '咖啡教学', date: '2026-06-28' },
      { number: 49, title: '猫咪生病', date: '2026-06-26' },
      { number: 48, title: '周年庆', date: '2026-06-24' },
    ],
    comments: [],
  },
];

export const categoryInfo = [
  { slug: 'love', name: '恋爱漫画', description: '甜蜜浪漫的爱情故事，少女心满满', count: 3200 },
  { slug: 'action', name: '动作漫画', description: '热血激燃的战斗场面，肾上腺素飙升', count: 2800 },
  { slug: 'fantasy', name: '奇幻漫画', description: '魔法与冒险交织的异世界之旅', count: 2500 },
  { slug: 'suspense', name: '悬疑漫画', description: '烧脑推理与惊悚悬疑的完美融合', count: 1900 },
  { slug: 'sf', name: '科幻漫画', description: '未来科技与宇宙探索的无限畅想', count: 1500 },
  { slug: 'comedy', name: '搞笑漫画', description: '轻松搞笑的日常喜剧，笑到停不下来', count: 2100 },
  { slug: 'horror', name: '恐怖漫画', description: '惊悚恐怖的悬疑故事，胆大你就来', count: 1200 },
  { slug: 'daily', name: '日常漫画', description: '温馨治愈的日常生活点滴', count: 1800 },
];

export function getComicsByCategory(slug: string) {
  return allComics.filter((comic) => comic.categorySlug === slug);
}

export function getComicById(id: string) {
  return allComics.find((comic) => comic.id === id) || null;
}

export function getSimilarComics(currentId: string, categorySlug: string, limit = 4) {
  return allComics
    .filter((comic) => comic.id !== currentId && comic.categorySlug === categorySlug)
    .slice(0, limit);
}

export function getAllCategorySlugs() {
  return categoryInfo.map((c) => c.slug);
}